import React, { FC, useEffect } from "react";
import AuthContext from "../../contexts/AuthContext";
import { ToastContainer } from "react-toastify";
import App from "../../App";
import { disableAuth } from "../../services/axiosService";

interface WindowsAuthProps {
    openIdSettings: any;
    setOpenIdSettings: any;
}

const WindowsAuth:FC<WindowsAuthProps> = ({openIdSettings, setOpenIdSettings}) => {
    useEffect(() => {
        // Disable auth for Windows authentication or no authentication
        disableAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ openIdSettings, setOpenIdSettings }}> 
            <ToastContainer />
            <App />
        </AuthContext.Provider>
    );
}

export default WindowsAuth;